// extracted by mini-css-extract-plugin
export default {"main":"Szukaj_main__2szMw","icon_szukaj":"Szukaj_icon_szukaj__BTpz7","icon_clear":"Szukaj_icon_clear__7cTGy","szukajInput":"Szukaj_szukajInput__PEWQV","icon2":"Szukaj_icon2__E2GD0"};